/* eslint-disable */
import * as icon from 'vue-svgicon'
icon.register({
  'lightbulb': {
    width: 16,
    height: 16,
    viewBox: '0 0 48 48',
    data: '<path pid="0" d="M24 10.826c-.029 0 0 .005 0 .005-.029 0-.058-.005-.087-.005-5.315 0-9.086 3.858-9.086 9.174 0 2.823 1.304 4.528 2.455 6.033 1.119 1.463 2.085 2.727 2.085 4.967 0 .771.227 1.396.633 1.836V34c0 .275 1 1 1 1v.5c0 .275.214.5.489.5h5a.51.51 0 0 0 .511-.5V35s1-.725 1-1v-1.335c.302-.427.47-.986.47-1.665 0-2.24.978-3.504 2.097-4.967 1.15-1.505 2.477-3.21 2.477-6.033-.001-5.315-3.729-9.174-9.044-9.174zm4.977 13.992c-1.17 1.53-2.475 3.265-2.475 6.182h-5.135c0-2.917-1.327-4.651-2.497-6.182-1.097-1.434-2.043-2.672-2.043-4.818 0-4.224 2.95-7.174 7.173-7.174 4 0 7.097 2.95 7.097 7.174 0 2.146-1.023 3.385-2.12 4.818z"/><path pid="1" d="M24 12.826c-.418 0-.818.037-1.209.093.13.336.209.698.209 1.081a3 3 0 0 1-3 3 2.99 2.99 0 0 1-2.145-.907c-.657 1.098-1.029 2.421-1.029 3.907 0 2.146.947 3.385 2.043 4.818 1.17 1.53 2.497 3.265 2.497 6.182h5.135c0-2.917 1.305-4.651 2.475-6.182 1.097-1.434 2.12-2.672 2.12-4.818.001-4.224-3.096-7.174-7.096-7.174z" opacity=".3"/>'
  }
})



// WEBPACK FOOTER //
// ./src/compiled-icons/lightbulb.js